var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h6',[_c('router-link',{attrs:{"to":{ name: 'tutorial', params: { uuid: _vm.module }}}},[_c('b-icon-play-btn-fill'),_vm._v(" Aprende aqui. ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }